import React from 'react';
import { useTranslation } from 'react-i18next';

export const LoadingScreen: React.FC = () => {
  const { i18n } = useTranslation();

  return (
    <div className="app">
      <div className="container">
        <div className="login-card">
          <div style={{ textAlign: 'center', padding: '40px' }}>
            <div style={{ fontSize: '18px', color: '#666666' }}>
              {i18n.language === 'he' ? 'טוען...' : 'Loading...'}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};


